import { Permission } from "presentation/constant/ANAInfo/PermissionName";
import { AdhocHoldOfCntrProvider } from "presentation/store/AdhocHoldOfContainer/AdhocHoldOfCntrProvider";
import { ANAInfoWrapper } from "presentation/view/components/ANAInfo/ANAInfoWrapper";
import { MessageBarWrapper } from "presentation/view/components/MessageBarWrapper";
import { GridStyles } from "presentation/view/components/styled/NbisTable.styled";
import AdhocHoldOfCntrMaintenance from "presentation/view/section/AdhocHoldOfContainer/AdhocHoldOfCntrMaintenance";

const AdhocHoldOfCntrContMain = () => {
    return <ANAInfoWrapper permission={Permission.ADHOC_HOLD_OF_CONTAINER_MAINTENANCE}>
        <MessageBarWrapper>
            <AdhocHoldOfCntrProvider>
                <GridStyles />
                <AdhocHoldOfCntrMaintenance />
            </AdhocHoldOfCntrProvider>
        </MessageBarWrapper>
    </ANAInfoWrapper>
}

export default AdhocHoldOfCntrContMain;